module.exports = __webpack_public_path__ + "static/media/IMG_6394-min.93c1ea83.jpg";